import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-jaswinder',
  templateUrl: './jaswinder.component.html',
  styleUrls: ['./jaswinder.component.scss']
})
export class JaswinderComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getJaswinder();
  }
}
